<template>
  <div>
    <v-card class="mb-4">
      <v-card-title class="d-flex justify-space-between align-center py-3">
        <div class="d-flex align-center">
          <v-icon class="mr-2" color="primary">notifications</v-icon>
          <span class="headline">Trung tâm thông báo</span>
        </div>
        <v-btn
          color="primary"
          class="text-none"
          outlined
          @click="markAllAsRead"
          v-if="totalUnread > 0"
        >
          <v-icon left>done_all</v-icon>
          Đánh dấu đọc tất cả
        </v-btn>
      </v-card-title>
      
      <!-- Tabs for quick status filter -->
      <v-tabs v-model="activeTab" @change="tabChanged" class="px-4">
        <v-tab class="text-none">Tất cả</v-tab>
        <v-tab class="text-none">Chưa đọc</v-tab>
      </v-tabs>
    </v-card>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :server-items-length="totalRows"
      :options.sync="pagination"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 50, 100]
      }"
      class="elevation-1"
      @click:row="handleRowClick"
    >
      <!-- Severity column -->
      <template v-slot:item.Severity="{ item }">
        <v-chip :color="getSeverityColor(item.Severity)" dark small>
          {{ getSeverityText(item.Severity) }}
        </v-chip>
      </template>

      <!-- Title & Message column -->
      <template v-slot:item.Message="{ item }">
        <div :class="{'font-weight-bold black--text': item.Status === 0}" class="py-2">
          <div class="body-2">{{ item.Title }}</div>
          <div class="caption grey--text text--darken-1 mt-1">{{ item.Message }}</div>
        </div>
      </template>

      <!-- Status column -->
      <template v-slot:item.Status="{ item }">
        <v-icon :color="item.Status === 1 ? 'grey' : 'primary'">
          {{ item.Status === 1 ? 'drafts' : 'mark_email_unread' }}
        </v-icon>
      </template>

      <!-- CreatedDate column -->
      <template v-slot:item.CreatedDate="{ item }">
        {{ item.CreatedDate | display_date }}
      </template>

      <!-- Action column -->
      <template v-slot:item.action="{ item }">
        <v-btn
          v-if="item.Status === 0"
          small
          icon
          color="primary"
          title="Đánh dấu đã đọc"
          @click.stop="markAsRead(item.ID)"
        >
          <v-icon small>done</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { display_date } from "@/commons/formater";

export default {
  name: "NotificationList",
  filters: { display_date },
  data() {
    return {
      activeTab: 0,
      pagination: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ["CreatedDate"],
        sortDesc: [true]
      },
      headers: [
        {
          text: "Mức độ",
          value: "Severity",
          width: 120,
          sortable: true
        },
        {
          text: "Nội dung",
          value: "Message",
          sortable: false
        },
        {
          text: "Trạng thái",
          value: "Status",
          width: 120,
          sortable: true
        },
        {
          text: "Thời gian",
          value: "CreatedDate",
          width: 180,
          sortable: true
        },
        {
          text: "Thao tác",
          value: "action",
          width: 100,
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapState({
      items: state => state.notification.all.data || [],
      totalRows: state => state.notification.all.total || 0,
      loading: state => state.notification.loading,
      top5: state => state.notification.top5 || []
    }),
    totalUnread() {
      return this.top5.length;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.fetchData();
      },
      deep: true
    }
  },
  methods: {
    getSeverityColor(severity) {
      switch (severity) {
        case 'error': return 'red';
        case 'warning': return 'orange';
        case 'info':
        default:
          return 'blue';
      }
    },
    getSeverityText(severity) {
      switch (severity) {
        case 'error': return 'Lỗi';
        case 'warning': return 'Cảnh báo';
        case 'info':
        default:
          return 'Thông tin';
      }
    },
    fetchData() {
      let filter = [];
      if (this.activeTab === 1) {
        filter.push({
          column: 'Status',
          condition: 'equal',
          value: 0
        });
      }
      
      const param = {
        pagination: this.pagination,
        filter: filter
      };
      this.$store.dispatch("notification/getList", param);
    },
    tabChanged() {
      this.pagination.page = 1;
      this.fetchData();
    },
    markAsRead(id) {
      this.$store.dispatch("notification/markRead", id).then(() => {
        this.fetchData();
      });
    },
    markAllAsRead() {
      this.$store.dispatch("notification/markAllRead").then(() => {
        this.fetchData();
      });
    },
    handleRowClick(item) {
      this.$store.dispatch("notification/markRead", item.ID).then(() => {
        let params = {};
        if (item.ActionRouteParams) {
          try {
            params = typeof item.ActionRouteParams === 'string' 
              ? JSON.parse(item.ActionRouteParams) 
              : item.ActionRouteParams;
          } catch (e) {
            console.error("Failed to parse ActionRouteParams", e);
          }
        }
        
        if (item.ActionRouteName) {
          this.$router.push({ name: item.ActionRouteName, params: params }).catch(() => {});
        } else {
          this.fetchData();
        }
      });
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.fetchData);
    this.fetchData();
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.fetchData);
  }
};
</script>
